export const DEFAULT_SORT_FIELD = "TotalShare";
export const DEFAULT_SORT_DIRECTION = "desc";

export const GENERIC_REFERRAL_DOMAIN = "Referral";
